(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const cart = document.querySelector('[data-cart]');
    if (!cart) return;

    function updateItem(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () {
        window.location.reload();
      });
    }

    cart.querySelectorAll('[data-qty-control]').forEach(function (ctrl) {
      const display = ctrl.querySelector('[data-qty-display]');
      const minus = ctrl.querySelector('[data-qty-minus]');
      const plus = ctrl.querySelector('[data-qty-plus]');
      const key = ctrl.closest('[data-key]').getAttribute('data-key');
      let qty = parseInt(display.textContent, 10);

      minus.addEventListener('click', function () {
        if (qty <= 1) return;
        qty--;
        display.textContent = qty;
        updateItem(key, qty);
      });

      plus.addEventListener('click', function () {
        qty++;
        display.textContent = qty;
        updateItem(key, qty);
      });
    });

    cart.querySelectorAll('[data-remove-item]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const key = btn.closest('[data-key]').getAttribute('data-key');
        updateItem(key, 0);
      });
    });
  })();

  // Set cart attribute for surprise pairs (fulfillment cue on the order)
  (function () {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var surpriseCount = Math.floor(cart.item_count / 3);
        var current = (cart.attributes && cart.attributes.surprise_pairs) || '0';
        if (String(surpriseCount) !== String(current)) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { surprise_pairs: String(surpriseCount) } })
          });
        }
      })
      .catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const grids = document.querySelectorAll('[data-collection-grid]');
    grids.forEach(function(grid) {
      const chips = grid.querySelectorAll('.filter-chip');
      const cards = grid.querySelectorAll('[data-reveal]');
      if (!chips.length || !cards.length) return;

      chips.forEach(function(chip) {
        chip.addEventListener('click', function() {
          chips.forEach(function(c) {
            c.classList.remove('is-active');
            c.setAttribute('aria-selected', 'false');
          });
          chip.classList.add('is-active');
          chip.setAttribute('aria-selected', 'true');

          const filter = chip.getAttribute('data-filter');
          cards.forEach(function(card) {
            if (filter === 'all') {
              card.classList.remove('is-hidden');
              return;
            }
            const tags = (card.querySelector('.product-card') ? card.querySelector('.product-card').getAttribute('data-tags') : '') || '';
            if (tags.indexOf(filter) !== -1) {
              card.classList.remove('is-hidden');
            } else {
              card.classList.add('is-hidden');
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creators"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Video autoplay on scroll
  var videos = document.querySelectorAll('.creators__video');
  if (videos.length) {
    var videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.play();
        } else {
          entry.target.pause();
          entry.target.muted = true;
          var btn = entry.target.closest('.creators__media') && entry.target.closest('.creators__media').querySelector('[data-mute-toggle]');
          if (btn) btn.classList.remove('is-unmuted');
        }
      });
    }, { threshold: 0.2 });
    videos.forEach(function(v) { videoObserver.observe(v); });
  }

  document.querySelectorAll('[data-mute-toggle]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
      var media = btn.closest('.creators__media');
      var video = media && media.querySelector('.creators__video');
      if (!video) return;
      var isUnmuting = video.muted;
      if (isUnmuting) {
        document.querySelectorAll('.creators__video').forEach(function(v) {
          v.muted = true;
        });
        document.querySelectorAll('[data-mute-toggle]').forEach(function(b) {
          b.classList.remove('is-unmuted');
          b.setAttribute('aria-label', 'Unmute video');
        });
        video.muted = false;
        btn.classList.add('is-unmuted');
        btn.setAttribute('aria-label', 'Mute video');
      } else {
        video.muted = true;
        btn.classList.remove('is-unmuted');
        btn.setAttribute('aria-label', 'Unmute video');
      }
    });
  });

  // Mobile tap overlay
  var tiles = document.querySelectorAll('[data-creator-tile]');
  tiles.forEach(function(tile) {
    tile.addEventListener('click', function(e) {
      if (e.target.closest('a')) return;
      if (window.innerWidth >= 1024) return;
      e.stopPropagation();
      var isActive = tile.classList.contains('is-active');
      tiles.forEach(function(t) { t.classList.remove('is-active'); });
      if (!isActive) tile.classList.add('is-active');
    });
  });

  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-creator-tile]')) {
      tiles.forEach(function(t) { t.classList.remove('is-active'); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
(function() {
  const reveals = document.querySelectorAll('[data-reveal]');
  if (!reveals.length) return;

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });

  reveals.forEach(function(el) { observer.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[data-footer-accordion]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (window.innerWidth >= 768) return;
      const list = btn.nextElementSibling;
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (isOpen) {
        list.setAttribute('hidden', '');
      } else {
        list.removeAttribute('hidden');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  const header = document.querySelector('[data-header]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('#header-search');
  const mobileToggle = document.querySelector('[data-mobile-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  // Sticky header scrolled state
  let ticking = false;
  function updateHeaderState() {
    if (window.scrollY > 30) {
      header.setAttribute('data-scrolled', '');
    } else {
      header.removeAttribute('data-scrolled');
    }
    ticking = false;
  }
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeaderState);
      ticking = true;
    }
  }, { passive: true });

  // Search overlay
  function openSearch() {
    searchOverlay.setAttribute('data-open', '');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('search-open');
    setTimeout(function() { searchInput.focus(); }, 300);
  }
  function closeSearch() {
    searchOverlay.removeAttribute('data-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('search-open');
  }
  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  // Mobile menu
  function openMobileMenu() {
    mobileMenu.setAttribute('data-open', '');
    mobileMenu.setAttribute('aria-hidden', 'false');
    mobileToggle.setAttribute('aria-expanded', 'true');
    mobileToggle.setAttribute('aria-label', 'Close menu');
    document.body.classList.add('mobile-menu-open');
  }
  function closeMobileMenu() {
    mobileMenu.removeAttribute('data-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.setAttribute('aria-label', 'Open menu');
    document.body.classList.remove('mobile-menu-open');
  }
  if (mobileToggle) {
    mobileToggle.addEventListener('click', function() {
      if (mobileMenu.hasAttribute('data-open')) closeMobileMenu();
      else openMobileMenu();
    });
  }

  // Esc closes overlays
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      if (searchOverlay && searchOverlay.hasAttribute('data-open')) closeSearch();
      if (mobileMenu && mobileMenu.hasAttribute('data-open')) closeMobileMenu();
    }
  });

  // Predictive search
  var searchSuggestions = document.querySelector('[data-search-overlay-suggestions]');
  var debounceTimer = null;
  var activeIndex = -1;

  function formatMoney(cents) {
    return '\u20B9' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function getSuggestionItems() {
    return searchSuggestions ? searchSuggestions.querySelectorAll('.search-suggestion-item') : [];
  }

  function setActiveSuggestion(index) {
    var items = getSuggestionItems();
    items.forEach(function(item, i) { item.classList.toggle('is-active', i === index); });
    activeIndex = index;
  }

  function closeSuggestions() {
    if (searchSuggestions) searchSuggestions.hidden = true;
    activeIndex = -1;
  }

  function renderSuggestions(products) {
    if (!searchSuggestions) return;
    if (!products.length) {
      searchSuggestions.innerHTML = '<div class="search-suggestion-item__empty">Nothing found — try another word.</div>';
      searchSuggestions.hidden = false;
      return;
    }
    searchSuggestions.innerHTML = products.map(function(p) {
      var img = p.image
        ? '<img class="search-suggestion-item__img" src="' + p.image + '" alt="" width="48" height="48" loading="lazy">'
        : '<div class="search-suggestion-item__placeholder"></div>';
      var price = p.price ? '<span class="search-suggestion-item__price">' + formatMoney(p.price) + '</span>' : '';
      return '<a href="' + p.url + '" class="search-suggestion-item">' + img + '<span class="search-suggestion-item__title">' + p.title + '</span>' + price + '</a>';
    }).join('');
    searchSuggestions.hidden = false;
    activeIndex = -1;
  }

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var query = searchInput.value.trim();
      if (query.length < 1) { closeSuggestions(); return; }
      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderSuggestions(products);
          })
          .catch(closeSuggestions);
      }, 250);
    });

    searchInput.addEventListener('keydown', function(e) {
      var items = getSuggestionItems();
      if (!items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActiveSuggestion(Math.min(activeIndex + 1, items.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActiveSuggestion(Math.max(activeIndex - 1, -1)); }
      else if (e.key === 'Enter' && activeIndex >= 0) { e.preventDefault(); items[activeIndex].click(); }
    });
  }

  // Mobile accordion
  const accordionToggle = document.querySelector('.mobile-menu__accordion-toggle');
  if (accordionToggle) {
    accordionToggle.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      this.nextElementSibling.classList.toggle('is-closed');
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  var slideshow = document.querySelector('[data-hero-slideshow]');
  if (!slideshow) return;
  var slides = slideshow.querySelectorAll('[data-hero-slide]');
  if (slides.length <= 1) return;

  var current = 0;
  var timer = null;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    current = index;
    slides[current].classList.add('is-active');
  }

  function next() {
    goTo((current + 1) % slides.length);
  }

  function start() {
    timer = setInterval(next, 2000);
  }

  

  start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.main-product');
    if (!section) return;

    // ---- Mobile gallery dots ----
    var galleryTrack = section.querySelector('[data-pdp-gallery-track]');
    var galleryDots = section.querySelectorAll('[data-pdp-gallery-dot]');

    if (galleryTrack && galleryDots.length) {
      galleryTrack.addEventListener('scroll', function() {
        var index = Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth);
        galleryDots.forEach(function(dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }, { passive: true });

      galleryDots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var index = parseInt(dot.getAttribute('data-index'), 10);
          galleryTrack.scrollTo({
            left: index * galleryTrack.clientWidth,
            behavior: 'smooth'
          });
        });
      });
    }

    // ---- Variant switching ----
    var variantsScript = section.querySelector('[data-pdp-variants]');
    var variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (e) {
      variants = [];
    }

    var variantIdInput = section.querySelector('[data-pdp-variant-id]');
    var priceEl = section.querySelector('[data-pdp-price]');
    var stickyPriceEl = section.querySelector('[data-pdp-sticky-price]');
    var submitBtn = section.querySelector('[data-pdp-submit]');
    var submitText = section.querySelector('[data-pdp-submit-text]');
    var stickySubmit = section.querySelector('[data-pdp-sticky-submit]');
    var inputs = section.querySelectorAll('[data-pdp-variant-input]');

    function formatMoney(cents) {
      // Basic INR formatting fallback. Shopify's Liquid money filter handles this server-side initially.
      var amount = (cents / 100).toFixed(2);
      return '\u20B9' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function getSelectedOptions() {
      var groups = section.querySelectorAll('.main-product__variant-group');
      var selected = [];
      groups.forEach(function(group) {
        var checked = group.querySelector('input:checked');
        if (checked) selected.push(checked.value);
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function(v) {
        return v.options.every(function(opt, i) { return opt === selected[i]; });
      });
    }

    function updateVariant() {
      var selected = getSelectedOptions();
      var variant = findVariant(selected);
      if (!variant) return;

      if (variantIdInput) variantIdInput.value = variant.id;

      var priceStr = formatMoney(variant.price);
      if (priceEl) priceEl.textContent = priceStr;
      if (stickyPriceEl) stickyPriceEl.textContent = priceStr;

      if (variant.available) {
        if (submitBtn) submitBtn.disabled = false;
        if (submitText) submitText.textContent = 'Order this pair';
        if (stickySubmit) {
          stickySubmit.disabled = false;
          stickySubmit.textContent = 'Order';
        }
      } else {
        if (submitBtn) submitBtn.disabled = true;
        if (submitText) submitText.textContent = 'Sold out';
        if (stickySubmit) {
          stickySubmit.disabled = true;
          stickySubmit.textContent = 'Sold out';
        }
      }
    }

    inputs.forEach(function(input) {
      input.addEventListener('change', updateVariant);
    });

    // ---- Mobile sticky add-to-cart bar ----
    var stickyBar = section.querySelector('[data-pdp-sticky-bar]');
    var form = section.querySelector('[data-pdp-form]');

    if (stickyBar && form && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
          } else if (entry.boundingClientRect.top < 0) {
            // Form scrolled above viewport — show sticky bar
            if (window.innerWidth < 1024) {
              stickyBar.classList.add('is-visible');
            }
          }
        });
      }, { threshold: 0 });

      observer.observe(form);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["most-loved"] && !Shopify.designMode) return;
  try {
    
(function() {
  const track = document.querySelector('[data-products-track]');
  if (!track) return;

  const prevBtn = document.querySelector('[data-arrow-prev]');
  const nextBtn = document.querySelector('[data-arrow-next]');

  function getStep() {
    const firstCard = track.querySelector('.products__card');
    if (!firstCard) return 300;
    const gap = parseFloat(getComputedStyle(track).gap) || 24;
    return firstCard.offsetWidth + gap;
  }

  function updateArrowStates() {
    if (!prevBtn || !nextBtn) return;
    const atStart = track.scrollLeft <= 5;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    prevBtn.classList.toggle('is-disabled', atStart);
    nextBtn.classList.toggle('is-disabled', atEnd);
  }

  if (prevBtn) prevBtn.addEventListener('click', function() {
    track.scrollBy({ left: -getStep(), behavior: 'smooth' });
  });

  if (nextBtn) nextBtn.addEventListener('click', function() {
    track.scrollBy({ left: getStep(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateArrowStates, { passive: true });
  window.addEventListener('resize', updateArrowStates);
  updateArrowStates();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;

    const slides = pdp.querySelectorAll('.pdp-gallery__slide');
    const thumbs = pdp.querySelectorAll('.pdp-gallery__thumb');
    const dots = pdp.querySelectorAll('.pdp-gallery__dot');
    const track = pdp.querySelector('[data-pdp-gallery-track]');
    const galleryMain = pdp.querySelector('.pdp-gallery__main');
    const totalSlides = slides.length;

    let currentIndex = 0;
    let autoPlayTimer = null;
    let scrollTimer = null;

    function setActive(index) {
      currentIndex = index;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
      thumbs.forEach((t, i) => t.classList.toggle('is-active', i === index));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }

    function nextSlide() {
      const next = (currentIndex + 1) % totalSlides;
      setActive(next);
      if (track && window.innerWidth < 1024) {
        track.scrollTo({ left: track.clientWidth * next, behavior: 'smooth' });
      }
    }

    function startAutoPlay() {
      stopAutoPlay();
      if (totalSlides > 1) {
        autoPlayTimer = setInterval(nextSlide, 4000);
      }
    }

    function stopAutoPlay() {
      if (autoPlayTimer) { clearInterval(autoPlayTimer); autoPlayTimer = null; }
    }

    // Pause on hover (desktop)
    if (galleryMain) {
      galleryMain.addEventListener('mouseenter', stopAutoPlay);
      galleryMain.addEventListener('mouseleave', startAutoPlay);
      galleryMain.addEventListener('touchstart', stopAutoPlay, { passive: true });
      galleryMain.addEventListener('touchend', function() {
        setTimeout(startAutoPlay, 1500);
      }, { passive: true });
    }

    // Thumbnails
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setActive(parseInt(thumb.getAttribute('data-index'), 10));
        startAutoPlay();
      });
    });

    // Dots
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.getAttribute('data-index'), 10);
        if (track) track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
        setActive(index);
        startAutoPlay();
      });
    });

    // Mobile scroll sync
    if (track) {
      track.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          if (index !== currentIndex) setActive(index);
        }, 60);
      });
    }
    // Gallery arrows (desktop)
    const prevGalleryBtn = pdp.querySelector('[data-pdp-prev]');
    const nextGalleryBtn = pdp.querySelector('[data-pdp-next]');

    function updateGalleryArrows() {
      if (!prevGalleryBtn || !nextGalleryBtn || totalSlides <= 1) return;
      prevGalleryBtn.classList.toggle('is-disabled', currentIndex === 0);
      nextGalleryBtn.classList.toggle('is-disabled', currentIndex === totalSlides - 1);
    }

    if (prevGalleryBtn) prevGalleryBtn.addEventListener('click', () => {
      if (currentIndex > 0) { setActive(currentIndex - 1); stopAutoPlay(); updateGalleryArrows(); }
    });
    if (nextGalleryBtn) nextGalleryBtn.addEventListener('click', () => {
      if (currentIndex < totalSlides - 1) { setActive(currentIndex + 1); stopAutoPlay(); updateGalleryArrows(); }
    });
    thumbs.forEach((t) => t.addEventListener('click', updateGalleryArrows));
    dots.forEach((d) => d.addEventListener('click', updateGalleryArrows));
    updateGalleryArrows();

    // Variant picker
    pdp.querySelectorAll('.pdp-info__variant-option').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.parentElement.querySelectorAll('.pdp-info__variant-option').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });

    // AJAX add to cart — persistent state + full surprise progression
    const stickyCta = pdp.querySelector('[data-pdp-sticky-submit]');
    const form = pdp.querySelector('[data-pdp-form]');
    const ctaBtn = pdp.querySelector('.pdp-info__cta');
    const promptEl = pdp.querySelector('[data-pdp-prompt]');
    const promptMsg = pdp.querySelector('[data-pdp-prompt-msg]');
    const celebration = pdp.querySelector('[data-pdp-celebration]');
    const celebrationMsg = pdp.querySelector('[data-pdp-celebration-msg]');
    const celebrationClose = pdp.querySelector('[data-pdp-celebration-close]');
    const progressionData = pdp.querySelector('.pdp-progression-data');
    const addedLabel = ctaBtn ? (ctaBtn.dataset.addedLabel || 'In the bag.') : 'In the bag.';
    const originalLabel = ctaBtn ? ctaBtn.textContent.trim() : 'Order this pair';
    const productId = form ? parseInt(form.dataset.productId) : null;

    const msgs = {
      2: progressionData ? progressionData.getAttribute('data-prompt-2') : '',
      3: progressionData ? progressionData.getAttribute('data-celebrate-3') : '',
      5: progressionData ? progressionData.getAttribute('data-prompt-5') : '',
      6: progressionData ? progressionData.getAttribute('data-celebrate-6') : '',
      8: progressionData ? progressionData.getAttribute('data-prompt-8') : '',
      9: progressionData ? progressionData.getAttribute('data-celebrate-9') : ''
    };
    const promptCounts = [2, 5, 8];
    const celebrationCounts = [3, 6, 9];

    function setButtonAdded() {
  if (ctaBtn) { 
    ctaBtn.textContent = addedLabel; 
    ctaBtn.classList.add('is-added'); 
    ctaBtn.setAttribute('data-in-cart', 'true');
    ctaBtn.disabled = false;
    ctaBtn.style.pointerEvents = 'auto';
    ctaBtn.style.cursor = 'pointer';
  }
  if (stickyCta) { 
    stickyCta.textContent = addedLabel;
    stickyCta.setAttribute('data-in-cart', 'true');
    stickyCta.disabled = false;
    stickyCta.style.pointerEvents = 'auto';
  }
}

function resetButton() {
  if (ctaBtn) { 
    ctaBtn.textContent = originalLabel; 
    ctaBtn.classList.remove('is-added');
    ctaBtn.removeAttribute('data-in-cart');
    ctaBtn.disabled = false;
    ctaBtn.style.pointerEvents = 'auto';
    ctaBtn.style.cursor = 'pointer';
  }
  if (stickyCta) { 
    stickyCta.textContent = originalLabel;
    stickyCta.removeAttribute('data-in-cart');
    stickyCta.disabled = false;
    stickyCta.style.pointerEvents = 'auto';
  }
}

async function doRemoveFromCart() {
  try {
    const cartRes = await fetch('/cart.js');
    const cartData = await cartRes.json();
    const item = cartData.items.find(function(i) { return i.product_id === productId; });
    if (!item) { resetButton(); return; }
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    });
    resetButton();
    const newCart = await fetch('/cart.js').then(function(r) { return r.json(); });
    document.querySelectorAll('[data-cart-count]').forEach(function(el) { el.textContent = newCart.item_count; });
    if (window.refreshCartDrawer) window.refreshCartDrawer();
  } catch(e) {
    resetButton();
  }
}

    function showCelebration(message) {
      if (window.showCartCelebration) {
        window.showCartCelebration(message);
        return;
      }
      if (!celebration || !celebrationMsg) return;
      celebrationMsg.textContent = message;
      celebration.classList.remove('is-visible');
      void celebration.offsetWidth;
      celebration.classList.add('is-visible');

      // Confetti
      const confettiContainer = celebration.querySelector('[data-pdp-confetti]');
      if (confettiContainer && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        confettiContainer.innerHTML = '';
        const colors = ['#C9A96E', '#1F4D3C', '#EADFD4', '#F7F3EE', '#B8896C'];
        const count = 16;
        for (let i = 0; i < count; i++) {
          const dot = document.createElement('span');
          dot.className = 'pdp-confetti__dot';
          const size = Math.random() * 6 + 4;
          const angle = (i / count) * 360 + Math.random() * 20;
          const distance = Math.random() * 80 + 60;
          const tx = Math.cos(angle * Math.PI / 180) * distance;
          const ty = Math.sin(angle * Math.PI / 180) * distance;
          const color = colors[Math.floor(Math.random() * colors.length)];
          const delay = Math.random() * 150;
          dot.style.cssText = 'width:' + size + 'px;height:' + size + 'px;background:' + color + ';top:50%;left:50%;margin-top:-' + (size/2) + 'px;margin-left:-' + (size/2) + 'px;--tx:' + tx + 'px;--ty:' + ty + 'px;animation-delay:' + delay + 'ms;';
          confettiContainer.appendChild(dot);
        }
      }

      // Auto-dismiss after 4 seconds
      if (celebration._dismissTimer) clearTimeout(celebration._dismissTimer);
      celebration._dismissTimer = setTimeout(function() {
        celebration.classList.remove('is-visible');
      }, 4000);
    }

    function updateProgressState(count, trigger) {
      if (promptCounts.includes(count) && promptEl && promptMsg) {
        promptMsg.textContent = msgs[count] || '';
        promptEl.classList.remove('is-visible');
        void promptEl.offsetWidth;
        promptEl.classList.add('is-visible');
      } else if (promptEl) {
        promptEl.classList.remove('is-visible');
      }
      if (trigger && celebrationCounts.includes(count)) {
        showCelebration(msgs[count] || '');
      }
    }

    async function syncCartState() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
        if (productId) {
          const inCart = cart.items.some(item => item.product_id === productId);
          if (inCart) setButtonAdded();
        }
        updateProgressState(cart.item_count, false);
      } catch(e) {}
    }

    async function doAddToCart() {
  if (!form) return;
  if (ctaBtn) { ctaBtn.disabled = true; ctaBtn.textContent = '...'; }
  if (stickyCta) stickyCta.disabled = true;
  try {
    const addRes = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
    if (!addRes.ok) throw new Error();
    setButtonAdded();
    if (window.openCartDrawer) window.openCartDrawer();
        const cartEl = document.querySelector('a[href="/cart"]');
        if (cartEl) {
          cartEl.classList.remove('cart-icon-pop');
          void cartEl.offsetWidth;
          cartEl.classList.add('cart-icon-pop');
          cartEl.addEventListener('animationend', () => cartEl.classList.remove('cart-icon-pop'), { once: true });
        }
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
        updateProgressState(cart.item_count, true);
      } catch(e) {
        if (ctaBtn) { ctaBtn.textContent = originalLabel; ctaBtn.classList.remove('is-added'); ctaBtn.disabled = false; }
        if (stickyCta) { stickyCta.textContent = originalLabel; stickyCta.disabled = false; }
      }
    }

    if (celebrationClose) {
      celebrationClose.addEventListener('click', () => celebration && celebration.classList.remove('is-visible'));
    }
    if (form) form.addEventListener('submit', (e) => {
  e.preventDefault();
  if (ctaBtn && ctaBtn.hasAttribute('data-in-cart')) doRemoveFromCart();
  else doAddToCart();
});
if (stickyCta) stickyCta.addEventListener('click', function() {
  if (stickyCta.hasAttribute('data-in-cart')) doRemoveFromCart();
  else doAddToCart();
});
    syncCartState();

    // Start
    startAutoPlay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  const grid = document.querySelector('[data-reviews-grid]');
  if (!grid) return;

  const initial = parseInt(grid.getAttribute('data-initial') || '3', 10);
  const cards = Array.from(grid.querySelectorAll('.pdp-rev__card'));
  const actions = document.querySelector('[data-reviews-actions]');
  const btn = document.querySelector('[data-reviews-toggle]');
  const labelEl = document.querySelector('[data-reviews-show-label]');

  if (cards.length <= initial) {
    if (actions) actions.style.display = 'none';
    return;
  }

  const hiddenCount = cards.length - initial;
  let expanded = false;

  cards.forEach(function(card, i) {
    if (i >= initial) card.style.display = 'none';
  });

  if (labelEl) {
    labelEl.textContent = 'Show ' + hiddenCount + ' more review' + (hiddenCount !== 1 ? 's' : '');
  }

  if (btn) {
    btn.addEventListener('click', function() {
      expanded = !expanded;
      btn.setAttribute('data-expanded', expanded ? 'true' : 'false');
      if (expanded) {
        cards.forEach(function(card) { card.style.display = ''; });
        if (labelEl) labelEl.textContent = 'Show less';
      } else {
        cards.forEach(function(card, i) {
          if (i >= initial) card.style.display = 'none';
        });
        if (labelEl) {
          labelEl.textContent = 'Show ' + hiddenCount + ' more review' + (hiddenCount !== 1 ? 's' : '');
        }
        grid.closest('.pdp-rev').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-story"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var revealEls = document.querySelectorAll('.pdp-story [data-reveal]');
    if (!revealEls.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

      revealEls.forEach(function(el) { observer.observe(el); });
    } else {
      revealEls.forEach(function(el) { el.classList.add('is-visible'); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  const form = document.querySelector('.search-form');
  const input = form && form.querySelector('.search-form__input');
  const suggestions = form && form.querySelector('[data-search-suggestions]');
  if (!input || !suggestions) return;

  let debounceTimer = null;
  let activeIndex = -1;

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function getItems() {
    return suggestions.querySelectorAll('.search-suggestion');
  }

  function setActive(index) {
    const items = getItems();
    items.forEach(function(item, i) {
      item.classList.toggle('is-active', i === index);
    });
    activeIndex = index;
  }

  function closeSuggestions() {
    suggestions.hidden = true;
    activeIndex = -1;
  }

  function renderResults(products) {
    if (!products.length) {
      suggestions.innerHTML = '<p class="search-suggestions__empty">Nothing found — try a different word.</p>';
      suggestions.hidden = false;
      return;
    }
    suggestions.innerHTML = products.map(function(p) {
      var img = p.image
        ? '<img class="search-suggestion__img" src="' + p.image + '" alt="" width="44" height="44" loading="lazy">'
        : '<div class="search-suggestion__img--placeholder"></div>';
      var price = p.price ? '<div class="search-suggestion__price">' + formatMoney(p.price) + '</div>' : '';
      return '<a href="' + p.url + '" class="search-suggestion">'
        + img
        + '<div class="search-suggestion__info">'
        + '<div class="search-suggestion__title">' + p.title + '</div>'
        + price
        + '</div>'
        + '</a>';
    }).join('');
    suggestions.hidden = false;
    activeIndex = -1;
  }

  function fetchSuggestions(query) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products);
      })
      .catch(function() { closeSuggestions(); });
  }

  input.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    var query = input.value.trim();
    if (query.length < 2) { closeSuggestions(); return; }
    debounceTimer = setTimeout(function() { fetchSuggestions(query); }, 250);
  });

  input.addEventListener('keydown', function(e) {
    var items = getItems();
    if (!items.length) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActive(Math.min(activeIndex + 1, items.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive(Math.max(activeIndex - 1, -1));
    } else if (e.key === 'Enter' && activeIndex >= 0) {
      e.preventDefault();
      items[activeIndex].click();
    } else if (e.key === 'Escape') {
      closeSuggestions();
    }
  });

  document.addEventListener('click', function(e) {
    if (!form.contains(e.target)) closeSuggestions();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.querySelector('[data-stats]');
  if (!section) return;

  const counters = section.querySelectorAll('[data-count-target]');
  let hasAnimated = false;

  function animateCount(el) {
    const target = parseFloat(el.dataset.countTarget);
    const decimals = parseInt(el.dataset.countDecimals || '0', 10);
    const suffix = el.dataset.countSuffix || '';
    const duration = 1600;
    const startTime = performance.now();

    function update(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = target * eased;

      el.textContent = decimals
        ? value.toFixed(decimals) + suffix
        : Math.round(value).toLocaleString() + suffix;

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }

    requestAnimationFrame(update);
  }

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting && !hasAnimated) {
        hasAnimated = true;
        counters.forEach(function(el, i) {
          setTimeout(function() {
            animateCount(el);
          }, i * 120);
        });
        observer.disconnect();
      }
    });
  }, { threshold: 0.35 });

  observer.observe(section);

  // Respect reduced motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    hasAnimated = true;
    counters.forEach(function(el) {
      const target = parseFloat(el.dataset.countTarget);
      const decimals = parseInt(el.dataset.countDecimals || '0', 10);
      const suffix = el.dataset.countSuffix || '';
      el.textContent = decimals
        ? target.toFixed(decimals) + suffix
        : Math.round(target).toLocaleString() + suffix;
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"] && !Shopify.designMode) return;
  try {
    
(function() {
  const page = document.querySelector('[data-wishlist-page]');
  if (!page) return;

  const grid = page.querySelector('[data-wishlist-grid]');
  const productsWrap = page.querySelector('[data-wishlist-products]');
  const emptyWrap = page.querySelector('[data-wishlist-empty]');
  const countText = page.querySelector('[data-wishlist-count-text]');

  // Read saved handles from localStorage
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem('cropoffs-wishlist') || '[]'); } catch(e) {}

  if (saved.length === 0) {
    emptyWrap.removeAttribute('hidden');
    return;
  }

  // Show products section
  productsWrap.removeAttribute('hidden');
  if (emptyWrap) emptyWrap.setAttribute('hidden', '');
  if (countText) countText.textContent = saved.length + ' piece' + (saved.length !== 1 ? 's' : '') + ' saved';

  // Fetch each product and render a card
  Promise.all(saved.map(handle =>
    fetch('/products/' + handle + '.js').then(r => r.json()).catch(() => null)
  )).then(products => {
    products.forEach(product => {
      if (!product) return;
      const price = (product.price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
      const image = product.featured_image || '';
      const isOne = product.tags && product.tags.some(t => t.toLowerCase().includes('one of one'));

      const card = document.createElement('div');
      card.setAttribute('data-wishlist-card', '');
      card.innerHTML = `
        <a href="/products/${product.handle}" class="product-card">
          <div class="product-card__media">
            ${image ? `<img src="${image}&width=600" alt="${product.title}" class="product-card__image" loading="lazy">` : '<div class="product-card__placeholder"></div>'}
            ${isOne ? '<span class="product-card__badge product-card__badge--one">One of one</span>' : ''}
            <button class="product-card__save" aria-pressed="true" data-wishlist-toggle data-product-handle="${product.handle}" type="button">
              <svg class="product-card__save-icon" width="14" height="14" viewBox="0 0 24 24" fill="#C8413A" stroke="#C8413A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
              </svg>
            </button>
          </div>
          <div class="product-card__info">
            <h3 class="product-card__title">${product.title}</h3>
            <p class="product-card__price">${price}</p>
          </div>
        </a>
      `;
      grid.appendChild(card);
    });

    // Remove from wishlist on heart click
    grid.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const handle = this.getAttribute('data-product-handle');
        let list = [];
        try { list = JSON.parse(localStorage.getItem('cropoffs-wishlist') || '[]'); } catch(e) {}
        list = list.filter(h => h !== handle);
        localStorage.setItem('cropoffs-wishlist', JSON.stringify(list));
        this.closest('[data-wishlist-card]').style.opacity = '0';
        setTimeout(() => { this.closest('[data-wishlist-card]').remove();
          if (grid.children.length === 0) {
            productsWrap.setAttribute('hidden', '');
            emptyWrap.removeAttribute('hidden');
          }
        }, 300);
      });
    });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
